import { Component, Input } from '@angular/core';

import { BaseFormList, MessageService } from '../../../../core';

import { RepresentanteGerente } from './representante-gerente';
import { Usuario } from '../../../usuario';

@Component({
    selector: 'sgt-representante-gerente',
    templateUrl: './representante-gerente.component.html',
    styleUrls: ['./representante-gerente.component.less']
})
export class RepresentanteGerenteComponent implements BaseFormList<RepresentanteGerente> {
    @Input() entities: RepresentanteGerente[];

    constructor(private messageService: MessageService) { }

    /** Ao alterar o usuário gerente */
    onChangeUsuario(entity: RepresentanteGerente, usuarioGerente: Usuario) {
        if (usuarioGerente) {
            entity.idUsuarioGerente = usuarioGerente.id;
        } else {
            entity.idUsuarioGerente = null;
        }
    }


    insert() {
        const entity = new RepresentanteGerente();
        this.entities.push(entity);
    }

    delete(index: number) {
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir o gerente ${(entity && entity.usuarioGerente) ? entity.usuarioGerente.nome : ''} do representante?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os gerentes do representante estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];


            const count = this.entities.filter(entityFilter => entityFilter.idUsuarioGerente && entityFilter.idUsuarioGerente === entity.idUsuarioGerente).length;
            const nome = (entity && entity.usuarioGerente) ? entity.usuarioGerente.nome : ''
            if (count > 1) {
                this.messageService.info(`O gerente ${nome} já está adicionado. Remova ou altere o gerente duplicado`, 'Não é possível adicionar o mesmo gerente mais de uma vez');
                return false;
            }
        }

        return true;
    }

    /** Resolve os gerentes do representante */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idUsuarioGerente) {
                this.entities.splice(i, 1);
            }
        }
    }
}
